import { gql } from 'apollo-boost';
import { useMutation } from '../';

export const updateIndicator = gql`
  mutation updateIndicator(
    $id: Int!,
    $name: String!,
    $definition: String!,
    $stageId: Int!,
    $guidance: String!,
    $tagList: String!,
    $benchmarkType: String,
    $measurementTypeId: Int,
    $servicesList: String,
    $customizable: Boolean,
  ) {
  updateIndicator(
    id: $id,
    name: $name,
    definition: $definition,
    stageId: $stageId,
    guidance: $guidance,
    tagList: $tagList,
    benchmarkType: $benchmarkType,
    measurementTypeId: $measurementTypeId,
    servicesList: $servicesList,
    customizable: $customizable
  ) {
      success
      id
    }
  }
`;

export function useUpdateIndicator() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(updateIndicator, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}
